export var LevelSortType;
(function (LevelSortType) {
    LevelSortType["DENSITY"] = "density";
    LevelSortType["DEVIATION"] = "deviation";
    LevelSortType["ENJOYMENT"] = "enjoyment";
    LevelSortType["ENJOYMENT_COUNT"] = "enjoymentCount";
    LevelSortType["LEVEL_ID"] = "ID";
    LevelSortType["NAME"] = "name";
    LevelSortType["OBJECT_COUNT"] = "objectCount";
    LevelSortType["POPULARITY"] = "popularity";
    LevelSortType["RANDOM"] = "random";
    LevelSortType["RATING"] = "rating";
    LevelSortType["RATING_COUNT"] = "ratingCount";
    LevelSortType["SECONDS"] = "seconds";
})(LevelSortType || (LevelSortType = {}));
export var LevelTwoPlayerMode;
(function (LevelTwoPlayerMode) {
    LevelTwoPlayerMode["ANY"] = "any";
    LevelTwoPlayerMode["NONE"] = "no";
    LevelTwoPlayerMode["ONLY"] = "only";
})(LevelTwoPlayerMode || (LevelTwoPlayerMode = {}));
